module.exports = __webpack_public_path__ + "static/img/nawiDalej-OFF.3ed4a90e.png";